import { apiFetch } from "./apiClient";

/** Maps to the backend's MenuMasterDto — the fixed set of app modules
 * (Dashboard, Bookings, Events & Halls, ...), shared across all accounts. */
export interface MenuMasterDto {
  menuId: number;
  parentMenuId: number | null;
  parentMenuDisplayName: string | null;
  menuName: string;
  displayName: string;
  menuUrl: string | null;
  icon: string | null;
  displayOrder: number | null;
  isActive: boolean;
  createdOn: string;
}

/** Shape accepted by both create and update (matches CreateMenuMasterDto/UpdateMenuMasterDto). */
export interface MenuMasterPayload {
  parentMenuId: number | null;
  menuName: string;
  displayName: string;
  menuUrl: string | null;
  icon: string | null;
  displayOrder: number | null;
  isActive: boolean;
}

export const listMenuMasters = async (): Promise<MenuMasterDto[]> => {
  const res = await apiFetch("/menumasters");
  return res.json();
};

export const getMenuMaster = async (menuId: number): Promise<MenuMasterDto> => {
  const res = await apiFetch(`/menumasters/${menuId}`);
  return res.json();
};

export const createMenuMaster = async (
  payload: MenuMasterPayload
): Promise<MenuMasterDto> => {
  const res = await apiFetch("/menumasters", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const updateMenuMaster = async (
  menuId: number,
  payload: MenuMasterPayload
): Promise<void> => {
  await apiFetch(`/menumasters/${menuId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
};

export const deleteMenuMaster = async (menuId: number): Promise<void> => {
  await apiFetch(`/menumasters/${menuId}`, { method: "DELETE" });
};
